export default __webpack_public_path__ + "static/gatling-4a61b1060c978e867294dd86d5e03969.png";